// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"2a425298","453":"8314f048"}[chunkId] + ".chunk.js";
};